function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1807 9.63766L13.8823 6.89757L5.15617 1.92334C4.57784 1.60643 4.03606 1.56195 3.56097 1.90851L11.1807 9.63766ZM14.3427 12.8457L17.1512 11.2435C17.6994 10.9322 18 10.4911 18 10.0018C18 9.51349 17.6994 9.07148 17.1522 8.76012L14.6095 7.31178L11.7471 10.214L14.3427 12.8457V12.8457ZM3.09136 2.58218C3.03289 2.76473 3 2.96859 3 3.19192V16.8182C3 17.1713 3.07675 17.4752 3.21562 17.7171L10.6133 10.2131L3.09136 2.58218ZM11.1807 10.7876L3.8241 18.2499C3.96479 18.3046 4.11646 18.3333 4.27634 18.3333C4.5614 18.3333 4.85833 18.248 5.16074 18.0775L13.6164 13.2618L11.1807 10.7876V10.7876Z",
  fill: "#C0D7D2"
});

function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.18eddcc6.svg";
export { ForwardRef as ReactComponent };